import React from 'react';
import { Container, Heading1, ProfilePic, Paragraph, Button } from '../style';
import styled from 'styled-components';
import Alfan from '../assets/alfan.png';
import { links } from '../data/linksData';
import { useHistory } from 'react-router-dom';

const Links = () => {
    const history = useHistory();

    return (
        <>
            <Center>
                <ProfilePic src={Alfan} alt={Alfan} />
                <Heading1 marginTop='1rem'>Hi guys! 👋🏻</Heading1>
                <Paragraph center>
                    Wanna see more cool stuff?
                    <br />
                    Follow these links ⤵️
                </Paragraph>
                <Container noPadding fullWidth margin='1.25rem 0'>
                    {links.map((link, idx) => (
                        <React.Fragment key={idx}>
                            <Paragraph small center>
                                {link.label}
                            </Paragraph>
                            {!link.url.includes('http') ? (
                                <Button
                                    onClick={() => history.push('/')}
                                    secondary={link.secondary}
                                    fullWidth
                                >
                                    {link.icon}
                                    {link.title}
                                </Button>
                            ) : (
                                <Button
                                    as='a'
                                    href={link.url}
                                    target='_blank'
                                    secondary={link.secondary}
                                    fullWidth
                                >
                                    {link.icon}
                                    {link.title}
                                </Button>
                            )}
                        </React.Fragment>
                    ))}
                </Container>
            </Center>
        </>
    );
};

export default Links;

const Center = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
